import React, { Component, createRef } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {
  Card,
  Form,
  Button,
  ButtonGroup,
  Row,
  Col,
  Table
} from "react-bootstrap";
import {
  FaSearch,
  FaEraser,
  FaChevronLeft,
  FaChevronRight
} from "react-icons/fa";
import api from "../../services/api";
import {
  hasPerm,
  formataDataExibicao
} from '../../common/utils';
import moment from 'moment-timezone';

class ComplianceAtendimento extends Component {
  constructor(props) {
    super(props);
    
    // datas iniciais
    const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
    const endOfMonth   = moment().endOf('month').format('YYYY-MM-DD');

    this.state = {
      listRegistros: [],
      error: "",
      loading: true,
      loadingBotao: false,

      // filtros de data
      filtro_data_inicio: startOfMonth,
      filtro_data_fim:   endOfMonth,

      // filtro de status
      filtro_status_compliance: '',

      // seletor de meses
      monthOffset: 0,
      selectedMonthLabel: `${moment().format('MMM').toLowerCase()}/${moment().year()}`,
    };
  }

  componentDidMount() {
    this.consultaRegistro();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.atendimento_id !== this.props.atendimento_id ||
      prevProps.cliente_id !== this.props.cliente_id ||
      prevProps.programa_id !== this.props.programa_id
    ) {
      this.consultaRegistro();
    }
  }

  consultaRegistro = () => {
    const { filtro_data_inicio, filtro_data_fim, filtro_status_compliance } = this.state;
    const { atendimento_id, cliente_id, programa_id } = this.props;
    this.setState({ loading: true });

    let filtros = `?data_inicio=${filtro_data_inicio}` +
                  `&data_fim=${filtro_data_fim}` +
                  `&atendimento_id=${encodeURIComponent(atendimento_id)}` +
                  `&status_atendimento=4`;
    if (cliente_id)  filtros += `&cliente_id=${encodeURIComponent(cliente_id)}`;
    if (programa_id) filtros += `&programa_id=${encodeURIComponent(programa_id)}`;
    if (filtro_status_compliance !== '') filtros += `&realizado=${filtro_status_compliance}`;

    api.get(`/atendimentos/aplicacoes/relatorio/${filtros}`)
      .then(({ data }) => this.setState({ listRegistros: data, loading: false, error: "" }))
      .catch(() => this.setState({ loading: false, error: 'Erro ao consultar compliance.' }));
  }

  handleChangeFiltros = e => {
    this.setState({ filtro_status_compliance: e.target.value }, () => this.consultaRegistro());
  }

  filtrarCompliance = e => { e.preventDefault(); this.consultaRegistro(); }
  
  limparFiltros = () => {
    const start = moment().startOf('month').format('YYYY-MM-DD');
    const end   = moment().endOf('month').format('YYYY-MM-DD');
    this.setState({
      filtro_data_inicio: start,
      filtro_data_fim: end,
      filtro_status_compliance: '',
      monthOffset: 0,
      selectedMonthLabel: `${moment().format('MMM').toLowerCase()}/${moment().year()}`
    }, () => this.consultaRegistro());
  }

  prevMonths = () => this.setState(({ monthOffset }) => ({ monthOffset: monthOffset + 6 }));
  nextMonths = () => this.setState(({ monthOffset }) => ({ monthOffset: Math.max(monthOffset - 6, 0) }));
  handleMonthSelect = opt => {
    const start = moment({ year: opt.year, month: opt.month }).startOf('month').format('YYYY-MM-DD');
    const end   = moment({ year: opt.year, month: opt.month }).endOf('month').format('YYYY-MM-DD');
    this.setState({ filtro_data_inicio: start, filtro_data_fim: end, selectedMonthLabel: opt.label }, () => {
      this.consultaRegistro();
    });
  }

  renderRows = () => {
    const { listRegistros } = this.state;
    if (listRegistros.atendimentos?.length) {
        return listRegistros.atendimentos.map((item, idx) => {
            const motivosList = listRegistros.aplicacoes
            ?.filter(app => app.atendimento_id === item.atendimento_id && app.aplicacao_status__realizado === false)
            .map(app => app.motivo)
            .filter(Boolean);
            const motivos = motivosList.length ? motivosList.join(' / ') : '-';
            return (
            <tr key={idx}>
                <td>{item.frequencia_aplicacao || '-'}</td>
                <td>{item.compliance ? 'Realizado' : 'Não Realizado'}</td>
                <td>{motivos}</td>
                <td>{item.dt_terapia_iniciada ? formataDataExibicao(item.dt_terapia_iniciada) : '-'}</td>
                <td>{item.data_ultima_aplicacao ? formataDataExibicao(item.data_ultima_aplicacao) : '-'}</td>
                <td>{item.data_ultimo_contato ? formataDataExibicao(item.data_ultimo_contato) : '-'}</td>
                <td>{item.tipo_contato || '-'}</td>
                <td>{item.canal_contato || '-'}</td>
            </tr>
            );
        });
    }
    return <tr><td colSpan={8}>Nenhum registro encontrado</td></tr>;
  }

  render() {
    if (!hasPerm('view_agendamentos')) return <Navigate to="/sem-permissao" />;
    const {
      monthOffset,
      selectedMonthLabel,
      loading,
      loadingBotao,
      listRegistros,
      filtro_data_inicio,
      filtro_data_fim,
      filtro_status_compliance
    } = this.state;
    const { atendimento_id, cliente_id, programa_id } = this.props;
    const monthNamesPt = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
    const monthOptions = [];
    for (let i = 5; i >= 0; i--) {
      const m = moment().subtract(monthOffset + i, 'months');
      monthOptions.push({ label: `${monthNamesPt[m.month()]}/${m.year()}`, year: m.year(), month: m.month() });
    }

    return (
      <div>
        {/* Filtros */}
        <Card className="cardDestaque mb-3">
          <Card.Body>
            {/* Seletor de meses */}
            <div className="d-flex justify-content-center align-items-center my-3">
              <Button variant="link" size="sm" onClick={this.prevMonths}><FaChevronLeft/></Button>
              <ButtonGroup size="sm" className="mx-2">
                {monthOptions.map(opt => (
                  <Button key={opt.label}
                    variant={selectedMonthLabel===opt.label?'secondary':'outline-secondary'}
                    onClick={()=>this.handleMonthSelect(opt)}
                    className="mx-1"
                  >{opt.label}</Button>
                ))}
              </ButtonGroup>
              <Button variant="link" size="sm" onClick={this.nextMonths}><FaChevronRight/></Button>
            </div>

            {/* Resumo */}
            <Row className="mb-3">
              <Col sm={6} xs={12}>
                <div className="row-list mb-2">
                    <p className="mb-0">Compliance - {this.state.selectedMonthLabel.toUpperCase()}</p>
                    <h4 className="mb-0">
                     {listRegistros.compliance ? 'Realizado' : 'Não Realizado'}
                    </h4>
                </div>
              </Col>
            </Row>

            {/* Tabela completa */}
            <Table responsive className="custom-table">
              <thead>
                <tr>
                  <th>Frequência Aplicação</th>
                  <th>Compliance</th>
                  <th>Motivo da Não Realização</th>
                  <th>Data Início Tratamento</th>
                  <th>Data Última Aplicação Realizada</th>
                  <th>Data Último Contato</th>
                  <th>Tipo Contato</th>
                  <th>Canal Contato</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={16}>Carregando...</td></tr>
                ) : (
                  listRegistros.atendimentos ?.length ? this.renderRows() : 
                  <tr><td colSpan={16}>Nenhum registro encontrado</td></tr>
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default withRouter(ComplianceAtendimento);